import { useState, useEffect } from "react";
import { Button, Dropdown, message } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import { serverFetch } from "../../server";
import "./button-report.css";
import { strDate2Server } from "../../extensions/utils";
import { isMobile } from "@/extensions/design";
import SportTooltip from "../sport-tooltip/sport-tooltip";

const ButtonReport = ({ vid, id, begPer, endPer, iconOnly, style }) => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const loadReports = async () => {
    if (!vid) return;
    
    setLoading(true);
    try {
      const data = await serverFetch(`reportdesign/short?vid=${vid}`);
      setReports(data || []);
    } catch (e) {
      console.error("Ошибка загрузки отчетов:", e);
      message.error(e.userMessage || "Ошибка загрузки списка отчетов");
      setReports([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (vid) {
      loadReports();
    }
  }, [vid]);

  const handleReportSelect = (reportId) => {
    // Формируем URL с параметрами
    let url = `/report?reportId=${reportId}`;

    if (id !== null && id !== undefined) {
      url += `&id=${id}`;
    }
    
    // Добавляем параметры периода если они переданы
    if (begPer !== null && begPer !== undefined) {
      url += `&begPer=${strDate2Server(begPer)}`;
    }
    if (endPer !== null && endPer !== undefined) {
      url += `&endPer=${strDate2Server(endPer)}`;
    }
    
    // Открываем в новом окне
    window.open(url, '_blank');
    setDropdownVisible(false);
  };

  const menuItems = reports.map(report => ({
    key: report.id,
    label: report.name,
    onClick: () => handleReportSelect(report.id)
  }));

  const dropdownProps = {
    menu: { items: menuItems },
    placement: 'bottomLeft',
    trigger: ['click'],
    open: dropdownVisible,
    onOpenChange: setDropdownVisible
  };

  const isDisabled = loading || reports.length === 0;

  if (!vid) {
    return null;
  }

  const iconButton = (
    <SportTooltip title="Печать">
      <Button
        className="icon-btn"
        loading={loading}
        disabled={isDisabled}
        style={style}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {!loading ? (
          <img
            src={isHovered && !isDisabled ? "/images/print-white.svg" : "/images/print-green.svg"}
            alt="print"
            width={24}
            height={24}
          />
        ) : null}
      </Button>
    </SportTooltip>
  );

  const plainIcon = (
    <PrinterOutlined
      className="client-mobile-var-button"
      style={{
        color: isDisabled ? "#999" : "#2f6f00",
        cursor: isDisabled ? "not-allowed" : "pointer",
        ...style
      }}
      onClick={(e) => {
        if (isDisabled || loading) return;
        e.stopPropagation();
      }}
    />
  );

  return (
    <div className="button-report" style={style}>
      <Dropdown {...dropdownProps}>
        {iconOnly === true ? (
          plainIcon
        ) : iconOnly === false ? (
          iconButton
        ) : (
          <Button icon={<PrinterOutlined />} loading={loading} disabled={isDisabled} style={style}>
            Печать
          </Button>
        )}
      </Dropdown>
    </div>
  );
};

export default ButtonReport;
